var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAmd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.293 64.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.32 76.62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-125.32 -76.619)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.271,15.911H11.665l-1.1-2.661H4.552l-1,2.661H0L5.419,2.472H9.3ZM7.409,5.683l-1.97,5.222H9.577Z",
    transform: "translate(0 -2.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.594,2.472h2.917V15.911h-3.35V7.517l-3.626,4.217h-.512L43.4,7.517v8.395h-3.35V2.472h2.916l4.315,4.985Z",
    transform: "translate(-23.223 -2.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5,2.472c4.906,0,7.429,3.054,7.429,6.739,0,3.862-2.443,6.7-7.8,6.7H80.564V2.472ZM83.914,13.448H86.1c3.369,0,4.374-2.286,4.374-4.257,0-2.305-1.241-4.256-4.414-4.256H83.914Z",
    transform: "translate(-46.719 -2.472)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.33,4.225H122.4L118.176,0h15.378V15.379l-4.224-4.225Z",
    transform: "translate(-118.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.216,18.16V12.073l-4.349,4.349V22.51h6.087L128.3,18.16Z",
    transform: "translate(-117.867 -7.001)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.572,56.907h12.154L101.572,67.374v3.521h17.476V67.4H106.9l12.152-10.466V53.413H101.572Z",
    transform: "translate(-58.902 -53.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.064,60.347l-5-6.934H48.74L56.3,63.9v6.994h3.493V63.9l7.6-10.487h-4.32Z",
    transform: "translate(-28.265 -53.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.029 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.477,
    height: 3.497,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.795,70.057V80.55h17.477v-3.5h-13.98v-3.5h13.98v-3.5Z",
    transform: "translate(-154.795 -70.057)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,63.9H9.95l4.038,6.995h4.038L13.988,63.9h0a3.5,3.5,0,0,0,3.5-3.5V56.9a3.5,3.5,0,0,0-3.5-3.5H0v3.5H13.741a.248.248,0,0,1,.248.248v3a.248.248,0,0,1-.248.248H0V70.894H3.5Z",
    transform: "translate(0 -53.407)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.014,53.42V65.574L212.548,53.42h-3.521V70.9h3.494V58.744L222.986,70.9h3.522V53.42Z",
    transform: "translate(-121.215 -53.415)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 105.282,
    height: 0.559,
    transform: "translate(0.011 47.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 54.578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.286,130.938H5.37v1.514H2.028v2.3c.514.014.742.029,1.285.057,1.671.086,2.214.928,2.214,2.186v.871c0,1.5-.543,2.442-3.1,2.442A8.906,8.906,0,0,1,0,139.964l.214-1.428a10.452,10.452,0,0,0,2.185.243c1.3,0,1.385-.314,1.385-1.071v-.457c0-.671-.214-.957-1.228-1s-1.514-.057-2.271-.071Z",
    transform: "translate(0 -130.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.174,137.553c0,1.428-.757,2.556-3.085,2.556S24,138.981,24,137.553v-4.4c0-1.428.757-2.556,3.085-2.556s3.085,1.128,3.085,2.556Zm-4.427-.171c0,.828.243,1.2,1.343,1.2s1.343-.371,1.343-1.2v-4.056c0-.828-.243-1.2-1.343-1.2s-1.343.371-1.343,1.2Z",
    transform: "translate(-13.92 -130.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.048,137.553c0,1.428-.757,2.556-3.085,2.556s-3.085-1.128-3.085-2.556v-4.4c0-1.428.757-2.556,3.085-2.556s3.085,1.128,3.085,2.556Zm-4.427-.171c0,.828.243,1.2,1.343,1.2s1.343-.371,1.343-1.2v-4.056c0-.828-.243-1.2-1.343-1.2s-1.343.371-1.343,1.2Z",
    transform: "translate(-28.924 -130.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.922,137.553c0,1.428-.757,2.556-3.085,2.556s-3.085-1.128-3.085-2.556v-4.4c0-1.428.757-2.556,3.085-2.556s3.085,1.128,3.085,2.556Zm-4.427-.171c0,.828.243,1.2,1.343,1.2s1.343-.371,1.343-1.2v-4.056c0-.828-.243-1.2-1.343-1.2s-1.343.371-1.343,1.2Z",
    transform: "translate(-43.929 -130.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.216,139.715a8.006,8.006,0,0,1-2.971-.571l.314-1.414a8.957,8.957,0,0,0,2.685.442c1.3,0,1.514-.271,1.514-1.185,0-1.057-.029-1.143-1.743-1.514-2.3-.514-2.613-.957-2.613-2.971,0-1.728.786-2.585,3.2-2.585a12.953,12.953,0,0,1,2.771.314l-.2,1.514a12.455,12.455,0,0,0-2.542-.286c-1.214,0-1.428.257-1.428,1.086,0,1.086.029,1.114,1.671,1.514,2.556.614,2.685,1.029,2.685,2.928C121.557,138.787,121.029,139.715,118.216,139.715Z",
    transform: "translate(-66.831 -129.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.288,130.258h5.828v1.585h-4.028v2.3H146.8v1.585h-3.714v2.457h4.028v1.585h-5.828Z",
    transform: "translate(-81.933 -130.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.045,139.769l-2.186-3.142h-1.714v3.142h-1.8v-9.511h3.9c2.214,0,3.028.9,3.028,2.571v1.243a2.168,2.168,0,0,1-1.428,2.3l2.356,3.4Zm-1.872-7.926h-2.028v3.228h2.028c.986,0,1.3-.357,1.3-1.157v-.943C171.473,132.172,171.131,131.843,170.174,131.843Z",
    transform: "translate(-96.465 -130.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.773,139.769h-1.8v-9.511h1.8Z",
    transform: "translate(-113.066 -130.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.294,130.258h5.827v1.585h-4.027v2.3h3.713v1.585h-3.713v2.457h4.027v1.585h-5.827Z",
    transform: "translate(-122.53 -130.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,139.715a8,8,0,0,1-2.97-.571l.314-1.414a8.963,8.963,0,0,0,2.686.442c1.3,0,1.514-.271,1.514-1.185,0-1.057-.029-1.143-1.743-1.514-2.3-.514-2.613-.957-2.613-2.971,0-1.728.785-2.585,3.2-2.585a12.947,12.947,0,0,1,2.771.314l-.2,1.514a12.461,12.461,0,0,0-2.542-.286c-1.214,0-1.428.257-1.428,1.086,0,1.086.029,1.114,1.671,1.514,2.556.614,2.685,1.029,2.685,2.928C241.746,138.787,241.218,139.715,238.4,139.715Z",
    transform: "translate(-136.529 -129.918)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmd);
export default __webpack_public_path__ + "static/media/logo_amd.df4ba583c8f53dccc14d0932d5e59f11.svg";
export { ForwardRef as ReactComponent };